import { render } from "./PlaceInterestView.vue?vue&type=template&id=0c06f192"
import script from "./PlaceInterestView.vue?vue&type=script&lang=js"
export * from "./PlaceInterestView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__